import React from 'react';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '@/components/ui/dialog';

export default function DiscardChangesDialog({ open, subject = 'customer profile', onCancel, onConfirm }) {
  return <Dialog open={open} onOpenChange={(next) => { if (!next) onCancel(); }}>
    <DialogContent aria-describedby="discard-description">
      <DialogHeader>
        <DialogTitle>Discard changes?</DialogTitle>
        <DialogDescription id="discard-description">You have unsaved {subject} changes. Discard them and leave this page?</DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <button type="button" onClick={onCancel} className="min-h-11 rounded-lg border border-border px-4 py-2">Keep editing</button>
        <button type="button" onClick={onConfirm} className="min-h-11 rounded-lg bg-destructive px-4 py-2 font-semibold text-destructive-foreground">Discard and leave</button>
      </DialogFooter>
    </DialogContent>
  </Dialog>;
}
